import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import hu from './locales/hu.json';
import ro from './locales/ro.json';

export default {
    en,
    hu,
    fr,
    de,
    ro
};
